import * as React from 'react'
import { useSWRConfig } from 'swr'

/**
 * Resets the SWR cache, completely (ie all keys).
 */
export function useResetSwrCache() {
  const { cache } = useSWRConfig()

  const resetSwrCache = React.useCallback(() => {
    for (const key of (cache as Map<string, unknown>).keys()) {
      cache.delete(key)
    }
  }, [cache])

  return resetSwrCache
}
